export default "__VITE_ASSET__CwUKjF$o__"